import { useDispatch, useSelector } from 'react-redux';
import updateOperators from '../../../actions/api/operators/updateOperators';
import { ACCOUNT_STATUS, REMOTE_SUPPORT_STATUS } from '../../../lib/constants';

/**
 * 削除済みユーザーを復元させるためのカスタムフック
 * @param {Function} onCancel 復元ダイアログを閉じる関数
 * @returns {{ handleRestore: Function, selectedUser: Object }} - ユーザーを復元させる関数と、復元対象ユーザーの詳細データ
 */
const useRestoreStaff = onCancel => {
  const dispatch = useDispatch();
  const apiToken = useSelector(state => state.main.apiToken);
  const selectedUser = useSelector(state => state.operator.confirmData);

  const handleRestore = () => {
    dispatch(
      updateOperators(apiToken, [
        {
          id: selectedUser.operatorId,
          role: selectedUser.role,
          accountStatus: ACCOUNT_STATUS.disable,
          remoteSupportStatus: REMOTE_SUPPORT_STATUS.disable,
        },
      ]),
    );
    onCancel();
  };

  return { handleRestore, selectedUser };
};

export default useRestoreStaff;
